module.exports = __webpack_public_path__ + "static/media/add talent sub-category.7ff64d24.svg";